function hueFromStableKey(seed: string, questionIndex = 0): number {
  let h = 0;
  const id = seed || `idx-${questionIndex}`;
  for (let i = 0; i < id.length; i++) {
    h = (h + id.charCodeAt(i) * (i * 13 + 7)) % 360;
  }
  return (h + questionIndex * 41 + questionIndex * questionIndex * 3) % 360;
}

/** Pastel panel behind question images — same logic as WITC for visual consistency. */
export function quizQuestionPanelBackground(questionIndex: number, questionId: string): string {
  return `hsl(${hueFromStableKey(questionId, questionIndex)}, 54%, 84%)`;
}

/** Tile Match / bar cards: one pastel per image key so all tiles in a trio share a color. */
export function tileMatchTilePanelStyle(imageAssetKey: string): {
  backgroundColor: string;
  borderColor: string;
} {
  const h = hueFromStableKey((imageAssetKey || '').trim().toLowerCase() || 'tile', 0);
  return {
    backgroundColor: `hsl(${h}, 54%, 84%)`,
    borderColor: `hsl(${h}, 42%, 52%)`,
  };
}
